import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "template", "row"]

  connect() {
    console.log("Requirements controller connected")
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(
      /INDEX_PLACEHOLDER/g,
      new Date().getTime()
    )
    this.itemsTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.target.closest("[data-requirements-target='row']").remove()
  }
}
